/* eslint-disable react-hooks/exhaustive-deps */
import { useSetState } from 'ahooks'
import { Form } from 'antd-mobile'
import { toJS } from 'mobx'
// import { FormInstance } from 'antd-mobile/es/components/form'
import { useLocalStore, observer } from 'mobx-react'
import React, { useEffect, useRef } from 'react'

import EditForm from '@/components/NewEditForm'

// import comstore from '@/pages/Component/Store'

import flowStore from '@/pages/Flow/Store'
import { FiledArrayCalculate } from '@/utils/index'
import { storage } from '@/utils/storage'

import { json } from './enum'
import { movementFieldApi, movementFieldValueApi, getSalaryDict } from './services'

import './index.less'

interface ReshuffleState {
  random: number
  filed: any[]
  filedValue: string
  filedValueList: any[]
  salaryTempList: any[]
  loding: boolean
}
interface ReshuffleProps {
  optionFilter?: string[]
  userId: string
  onClose: () => void
  selectedMovementFieldList: string[]
  is_show: boolean
}
const ChangedFieldName: string[] = ['POST', 'HRM_POSITION', 'POSITION_RANK']
const ChangedInputFieldName: string[] = ['BANK_ADDRESS', 'SALARY_BANK_NUMBER']
const ReshuffleFrom: React.FC<ReshuffleProps> = (props) => {
  const { userId = '', is_show = true, onClose, selectedMovementFieldList, optionFilter } = props
  const employee_id = storage.get('userData')?.employee_id || ''
  // const [formIt] = Form.useForm()
  const [formIt] = Form.useForm()

  const originalSalaryId = Form.useWatch(
    ['original_salary_value', 'salary_structure_template_id'],
    formIt
  )

  const changedSalaryId = Form.useWatch(
    ['changed_salary_value', 'salary_structure_template_id'],
    formIt
  )

  const formRef = useRef<any>()
  const { reshuffleStatus, changeReshuffle, reshuffle } = useLocalStore(() => flowStore)
  const [{ random, filed, salaryTempList, filedValueList, filedValue, loding }, setState] =
    useSetState<ReshuffleState>({
      random: 0,
      filed: [],
      salaryTempList: [],
      filedValue: '',
      filedValueList: [],
      loding: false
    })

  const fetchmovementField = async () => {
    setState({ loding: true })
    const { data } = await movementFieldApi()
    setState({ filed: data, loding: false })
    const setFieldValues = () => {
      console.log(reshuffleStatus, 'reshuffleStatus---->>>>')
      const fields = reshuffle?.find((x: any) => x?.active)
      let fieldValues: any = {
        original_value: fields?.original_value_name,
        changed_value: FiledArrayCalculate(fields?.changed_value, [
          { name: fields?.changed_value_name, id: fields?.changed_value }
        ])
      }

      setState({ filedValue: fields?.movement_field })
      // 薪酬结构
      if (fields?.movement_field === 'PAY_STRUCTURE') {
        fieldValues = fields
      }
      // 岗位 职位 职级
      if (ChangedFieldName.includes(fields?.movement_field)) {
        fieldValues.changed_value = {
          [fields?.movement_field]: [
            {
              name: fields?.changed_value_name,
              id: fields?.changed_value
            }
          ]
        }
      }
      // 岗位 职位 职级
      if (ChangedInputFieldName.includes(fields?.movement_field)) {
        fieldValues.changed_value = {
          [fields?.movement_field]: fields?.changed_value
        }
      }
      if (
        ![
          'ORG',
          'POST',
          'HRM_POSITION',
          'POSITION_RANK',
          'BANK_ADDRESS',
          'SALARY_BANK_NUMBER'
        ].includes(fields?.movement_field)
      ) {
        fieldValues.changed_value = {
          changed_value: fields?.changed_value
        }
      }
      fields?.movement_field && (fieldValues.movement_field = fields?.movement_field)
      formIt.setFieldsValue(fieldValues)
    }
    reshuffleStatus === 'Edit' && setFieldValues()
  }

  const fetchMovementFieldValue = async (userId?: any) => {
    const { data, code } = await movementFieldValueApi(userId || employee_id)
    if (code === 2000) {
      setState({ filedValueList: data })
    }
  }

  const deleteInfo = () => {
    reshuffleStatus === 'Edit' && changeReshuffle(reshuffle.filter((x) => !x.active))
    // Taro.navigateBack()
    onClose()
  }

  const getChangedValue = (changed_value: any) => {
    return filedValue === 'ORG'
      ? changed_value?.[0].id
      : ChangedFieldName.concat(ChangedInputFieldName).includes(filedValue)
        ? changed_value?.[filedValue]
        : changed_value.changed_value
  }

  const getChangedName = (changed_value: any, movement_field: any) => {
    const isOrg = filedValue === 'ORG'
    const isSelect = ChangedFieldName.includes(filedValue)
    const isInput = ChangedInputFieldName.includes(filedValue)
    if (isOrg) {
      return changed_value?.[0].name
    } else if (isSelect) {
      return filed
        .find((x) => x.type === movement_field)
        ?.details?.find((y: any) => y.value === changed_value?.[filedValue])?.name
    } else if (isInput) {
      return changed_value?.[filedValue]
    }
    return filed
      .find((x) => x.type === movement_field)
      ?.details?.find((y: any) => y.value === changed_value.changed_value)?.name
  }

  const onFinish = (fieldValues: any) => {
    const { movement_field, original_value, changed_value } = fieldValues
    console.log(fieldValues, movement_field, 'fieldValues', filed, filedValueList)
    const field = {
      ...fieldValues,
      movement_field_name: filed?.find((x) => x.type === movement_field)?.type_name,
      original_value_name: original_value,
      original_value: filedValueList.find((x) => x.movement_field === movement_field)
        ?.original_value_id,
      changed_value: getChangedValue(changed_value),
      changed_value_name: getChangedName(changed_value, movement_field)
    }
    console.log(field, 'params:')

    reshuffleStatus === 'Add' && changeReshuffle([...reshuffle, field])

    reshuffleStatus === 'Edit' &&
      changeReshuffle(
        reshuffle.map((x: any) => {
          if (x.active) return field
          return x
        })
      )
    onClose()
  }
  const handleChange = (event: any) => {
    setState({ filedValue: event })
    formIt.setFieldsValue({ changed_value: '' })
  }

  useEffect(() => {
    fetchmovementField()
    fetchMovementFieldValue(userId)
  }, [])
  const saveSubmit = () => {
    formIt.submit()
  }
  // 基本项排序
  const dealSalaryValue = (data: any) => {
    if (!data) {
      return data
    }
    const { salary_details, ...rest } = data || {}
    const { item_dtos } =
      salaryTempList?.find((item: any) => item?.id === rest?.salary_structure_template_id) || {}
    return {
      ...rest,
      salary_details: item_dtos?.map((item: any) => {
        const currentSalary = salary_details?.find(
          (salaryItem: any) => salaryItem?.code === item?.code
        )
        const { code, name } = item || {}
        return {
          code,
          name,
          value: currentSalary?.value
        }
      })
    }
  }

  useEffect(() => {
    const currentValue = filedValueList.find((x) => x.movement_field === filedValue)
    if (filedValue === 'PAY_STRUCTURE') {
      formIt.setFieldsValue({
        original_salary_value: dealSalaryValue(currentValue?.original_salary_value)
      })
    } else {
      formIt.setFieldsValue({ original_value: currentValue?.original_value })
    }
  }, [filedValue, filedValueList, reshuffleStatus])

  /** 获取薪酬模版 */
  useEffect(() => {
    let mounted = true
    getSalaryDict()
      .then(({ code, data }) => {
        if (mounted && code === 2000) {
          const filterFn = (x: any) => x?.base_item_flag === 1
          const tempData = data?.map((salaryItem: any) => ({
            ...salaryItem,
            item_dtos: salaryItem?.item_dtos?.filter(filterFn)
          }))
          setState({
            salaryTempList: tempData
          })
        }
      })
      .catch(() => {})
    return () => {
      mounted = false
    }
  }, [])

  useEffect(() => {
    setState({
      random: Math.random()
    })
  }, [originalSalaryId])

  useEffect(() => {
    if (changedSalaryId) {
      const { name } =
        salaryTempList?.find((item: any) => item?.id === changedSalaryId) || ({} as any)
      formIt.setFieldValue(['changed_salary_value', 'salary_structure_template_name'], name)
    }
  }, [changedSalaryId])

  console.log(filedValueList, 'Reshuffleform>>>>', filedValue)

  return (
    <div className='reshuffle-edit-form'>
      <EditForm
        // className='reshuffle-edit-form'
        randomForm={random}
        layout='horizontal'
        formInfo={json({
          filed,
          filedValue,
          optionFilter,
          selectedMovementFieldList,
          formInst: formIt,
          salaryTempList,
          handleChange,
          reshuffleStatus
        })}
        ref={formRef}
        // labelWidth={200}
        formInst={formIt}
        onFinish={onFinish}
      />
      <div onClick={saveSubmit} className='save-form-button'>
        保存
      </div>
      {reshuffleStatus === 'Edit' && (
        <div onClick={deleteInfo} className='delete-form-button'>
          删除
        </div>
      )}
    </div>
  )
}

export default observer(ReshuffleFrom)
